import React from "react";
import { basePath } from "./config";
import axios from "axios";
import {getAccessTokenApi, decodificaToken} from "./auth";
import { TIPO_SEDE,MSN_GUARDAR} from "../utils/constanst";
import {Modal} from "antd";

const TIPO_INTEGRANTE = [1];
const TIPO_STATUS = [1];

export function saveRequest(request) {
  const url = `${basePath}/solicitud`;
  const jwt = getAccessTokenApi();
  return axios.post(url, request, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: jwt},
  });
}

export function sendObservations(values, docFoto, docFrente, docVuelta, history, setButton, original, setLoader) {
  const { confirm } = Modal;
  const jwt = getAccessTokenApi();
  const token = decodificaToken(jwt);
    confirm({
       title:
         "Los datos corregidos serán revisados, se notificará el resultado al ciudadano mediante correo electrónico",
       icon: null,
       okText: "Enviar a revisión",
       cancelText: "Cancelar",
       cancelButtonProps: { className: "ant-btn-default" },
       onOk() {
        setLoader({ loading: true, message: MSN_GUARDAR }); //Se activa el loader
        const formData = new FormData();
        if (docFoto !== undefined) {
          formData.append("docFoto", docFoto);
        } else {
          formData.append("docFoto", null);
        }
        if (docFrente !== undefined) {
          formData.append("docFrente", docFrente);
        } else {
          formData.append("docFrente", null);
        }
        if (docVuelta !== undefined) {
          formData.append("docVuelta", docVuelta);
        } else {
          formData.append("docVuelta", null);
        }
        values.usuario=token.sub;
        formData.append(
          "solicitud",
          new Blob([JSON.stringify(values)], { type: "application/json" })
        );
        formData.append(
          "original",
          new Blob([JSON.stringify(original)], { type: "application/json" })
        );
        update(formData, history, setButton, setLoader)
      },
      onCancel() {
        setButton(false);
      }
    });
 }

 //Actualiza la solicitud atendiendo las observaciones
function update(register, history, setButton, setLoader) {
  updateChangesObs(register).then(res => {
    if (res.data.code === 200) {
      setLoader({ loading: false, message: "" }); //Se desactiva el loader
      history.push("/admin/observaciones");
    } else {
      setLoader({ loading: false, message: "" }); //Se desactiva el loader
      Modal.info({
        title: res.data.code === 400 ? "¡ATENCIÓN!" : "¡LO SENTIMOS!",
        content: <p>{res.data.causa}</p>
      });
      setButton(false);
    }
  });
}

export function updateChangesObs(register) {
  const url = `${basePath}/observaciones/actualizar`;
  const jwt = getAccessTokenApi();
  return axios.post(url, register, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: jwt},
  });
}

export function updateRequest(request) {
  const url = `${basePath}/solicitud/actualizar`;
  const jwt = getAccessTokenApi();
  return axios.post(url, request, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: jwt},
  });
}

export const getOrganitation = (codigo) => {
  const url = `${basePath}/solicitud/organizacion`;
  const jwt = getAccessTokenApi();
  return axios.post(
    url,
    { codigo: codigo },
    {
      headers: {
        Authorization: jwt},
    }
  );
};

export function getStatus(correo) {
  const url = `${basePath}/solicitud/estatus`;
  const jwt = getAccessTokenApi();
  return axios.post(
    url,
    { correo: correo },
    {
      headers: { Authorization: jwt},
    }
  );
}

export function getCursoPresencial(correo) {
  const url = `${basePath}/cursos/cursoPresencialCiudadano`;
  const jwt = getAccessTokenApi();
  return axios.post(
    url,
    { correo: correo },
    {
      headers: {Authorization: jwt},
    }
  );
}

export function getState() {
  const url = `${basePath}/geografico`;
  const jwt = getAccessTokenApi();
  return axios.post(
    url,
    {},
    {
      headers: {Authorization: jwt},
    }
  );
}


export function getOrganizacion(codigoOrganizacion) {
  const url = `${basePath}/solicitud/getOrganizacion`;
  const jwt = getAccessTokenApi();
  return axios.post(
    url,
    { codigoOrganizacion: codigoOrganizacion },
    {
      headers: { Authorization: jwt},
    }
  );
}

export function getEntidadesSeg() {
  const url = `${basePath}/solicitud/entidadesSeguimiento`;
  const jwt = getAccessTokenApi();
  return axios.post(
    url,
    {},
    {
      headers: { Authorization: jwt},
    }
  );
}

export function getMunicipio(idEstado) {
  const url = `${basePath}/municipio`;
  const jwt = getAccessTokenApi();
  return axios.post(
    url,
    { idEstado: idEstado },
    {
      headers: { Authorization: jwt},
    }
  );
}

export function getDownload(usuario, tipo, idObs) {
  const url = `${basePath}/solicitud/descarga`;
  const jwt = getAccessTokenApi();
  return axios.post(
    url,
    { usuario: usuario, tipo: tipo, idObservador: idObs },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: jwt},
      responseType: "blob",
    }
  );
}

export function getStudies() {
  const url = `${basePath}/solicitud/escolaridad`;
  const jwt = getAccessTokenApi();
  return axios.post(
    url,
    {},
    {
      headers: { Authorization: jwt},
    }
  );
}

/* export function getByJunta(idEstado, idCorte) {
  //const url = `${urlJuntas}/ws/domiciliosJunta/consulta`;
  //const url = `${basePath}/solicitud/junta`;
  //const url = `${basePath}/sesiones/domicilio`;
  const url = `${basePath}/sesiones/juntaEjecutiva`;
  const jwt = getAccessTokenApi();
  return axios.post(
    url,
    { idEstado: idEstado, tipoSede: TIPO_SEDE, idCorte: idCorte },
    {
      headers: { Authorization: jwt},
    }
  );
} */

/* export function getByJuntaTablasLoc(idEstado) {
  const url = `${basePath}/sesiones/juntaEjecutivaTablasLoc`;
  const jwt = getAccessTokenApi();
  return axios.post(
    url,
    { idEstado: idEstado, tipoSede: TIPO_SEDE },
    {
      headers: { Authorization: jwt, Origen: "portal", Parametrizacion: "0,0" },
    }
  );
} */

export function getByIdDistrito(idEstado, seccion) {
  const url = `${basePath}/solicitud/distrito`;
  const jwt = getAccessTokenApi();
  return axios.post(
    url,
    { idEntidad: idEstado, seccion: seccion },
    {
      headers: { Authorization: jwt},
    }
  );
}

export const getEntities = (idProceso, idDetalle) => {
  const url = `${basePath}/solicitud/observar`;
  const jwt = getAccessTokenApi();
  return axios.post(
    url,
    {
      idProceso:idProceso,
      idDetalle:idDetalle,
    },
    {
      headers: {
        Authorization: jwt},
    }
  );
};

// export function getFuncionarios(idEstado, idJunta) {
//   //const url = `${urlJuntas}/ws/integrantes/consulta`;
//   //const url = `${basePath}/cursos/funcionarios`;
//   const url = `${basePath}/sesiones/funcionarios`;
//   const jwt = getAccessTokenApi();
//   return axios.post(
//     url,
//     {
//       tipoIntegrante: TIPO_INTEGRANTE,
//       idEstado: idEstado,
//       idDistritoFederal: idJunta,
//       estatus: TIPO_STATUS
//     },
//     {
//       headers: { Authorization: jwt, Origen: "portal", Parametrizacion: "0,0" },
//     }
//   );
// }
////////////////////////// SERVICIOS PARA LA SOLICITUD EXTRANJERA //////////////////////////
export const getCountries = () => {
  const url = `${basePath}/solicitud/paises`;
  const jwt = getAccessTokenApi();
  return axios.post(
    url,
    {},
    {
      headers: {
        Authorization: jwt},
    }
  );
};
////////////////////////// SERVICIOS OBSERVACIONES EN EL REGISTRO CIUDADANO //////////////////////////
export function getByMailRegister(mail) {
  const url = `${basePath}/observaciones`;
  const jwt = getAccessTokenApi();
  return axios.post(
    url,
    { correo: mail },
    {
      headers: {
        Authorization: jwt},
    }
  );
}

export function getByMailRegisterAdmin(mail, claveElec) {
  const url = `${basePath}/observaciones`;
  const jwt = getAccessTokenApi();
  return axios.post(
    url,
    { correo: mail, claveElector:claveElec},
    {
      headers: {
        Authorization: jwt},
    }
  );
}

export function getJuntas(idEstado, idJunta, idCorte) {
  const url = `${basePath}/sesiones/juntaEjecutiva`;
  const jwt = getAccessTokenApi();
  return axios.post(
    url,
    { idEstado: idEstado, idDistritoFederal: idJunta, tipoSede: TIPO_SEDE, idCorte: idCorte },
    {
      headers: { Authorization: jwt},
    }
  );
}

export function getFuncionarios(idProceso, idDetalle, idEstado, idJunta) {
  const url = `${basePath}/sesiones/funcionarios`;
  const jwt = getAccessTokenApi();
  return axios.post(
    url,
    {
      id_proceso: idProceso, 
      id_detalle: idDetalle,
      tipoIntegrante: TIPO_INTEGRANTE,
      idEstado: idEstado,
      idDistritoFederal: idJunta,
      estatus: TIPO_STATUS
    },
    {
      headers: { Authorization: jwt},
    }
  );
}

export function validaClaveMail(values, modulo) {
  const url = `${basePath}/registroJuntas/validaClaveMail`;
  const jwt = getAccessTokenApi();
  return axios.post(url, { values: values, modulo: modulo }, {headers: { Authorization: jwt }});
}

export function getPaises() {
  const url = `${basePath}/observaciones/paises`;
  const jwt = getAccessTokenApi();
  return axios.post(
    url,
    {},
    {
      headers: {
        Authorization: jwt},
    }
  );
}

export function updateChanges(register) {
  const url = `${basePath}/observaciones/actualizar`;
  const jwt = getAccessTokenApi();
  return axios.post(url, register, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: jwt},
  });
}

export function getEstadoGralSolicitud(correo) {
  const url = `${basePath}/solicitudes/getEstadoGralSolicitudPortal`;
  const jwt = getAccessTokenApi();
  return axios.post(
    url,
    { correo: correo },
    {
      headers: { Authorization: jwt},
    }
  );
}

export function getEstadoCursoLinea(ciudadano){
  const url = `${basePath}/solicitud/estatusCursoLinea`;
  const jwt = getAccessTokenApi();
  return axios.post(
    url,
    { id: ciudadano.id },
    {
      headers: { Authorization: jwt},
    }
  );
}

export function getTieneAsistencia(correo) {
  const url = `${basePath}/solicitudes/getTieneAsistencia`;
  const jwt = getAccessTokenApi();
  return axios.post(
    url,
    { correo: correo },
    {
      headers: { Authorization: jwt},
    }
  );
}


export function getEstadoCurso(id) {
  const url = `${basePath}/cursos/linea/continuarCurso`;
  const jwt = getAccessTokenApi();
  return axios.post(
    url,
    { idObservador: id },
    {
      headers: { Authorization: jwt},
    }
  );
}

//FUNCION PARA SABER SI SE PUEDE COMENZAR EL CURSO
export function getEstadoMateriales(){
  const url=`${basePath}/cursos/linea/EstadoMateriales`;
  const jwt = getAccessTokenApi();
  return axios.post(
    url,
    {},
    {
      headers: { Authorization: jwt},
    }
  );
}

// Debido a la premura, se reutiliza la función de la junta ejecutiva que consulta la información al modificar una solicitud 
export function getDatosObservador(id) {
  const url = `${basePath}/registroJuntas/id`;
  const jwt = getAccessTokenApi();
  return axios.post(
    url,
    /* { idObservador: id, idProceso: "19", idDetalle: "142" }, */
    { idObservador: id },
    {
      headers: { Authorization: jwt},
    }
  );
}

export function guardarOCP(datos) {
  const url = `${basePath}/solicitud/actualizarObCP`;
  const jwt = getAccessTokenApi();
  return axios.post(url, datos, {
    headers: { Authorization: jwt},
  });
}

export function obtenDetallesPorProcesoPortal(idProceso) {
  const url = `${basePath}/registroJuntas/obtenDetallesPorProceso`;
  const jwt = getAccessTokenApi();
  return axios.post(
    url,
    { idProceso: idProceso },
    { headers: { Authorization: jwt} }
  );
}

export function obtenFechaJornada(idProceso, idDetalle) {
  const url = `${basePath}/solicitud/fechaJornada`;
  const jwt = getAccessTokenApi();
  return axios.post(
    url,
    { idProceso: idProceso, idDetalle: idDetalle },
    { headers: { Authorization: jwt} }
  );
}

export function getParametroPortal(idProceso, idDetalle, parametro) {
  const url = `${basePath}/parametro`;
  const jwt = getAccessTokenApi();
  return axios.post(url, 
    { idProceso: idProceso, idDetalle: idDetalle, parametro: parametro },
    { headers: { Authorization: jwt} }
  );
}

export function getPaisesVotoExtranjero() {
  const url = `${basePath}/registroJuntas/paisesVotoExtranjero`;
  const jwt = getAccessTokenApi();
  return axios.post( url, {}, { headers: { Authorization: jwt }});
}

export function getSedesVotoExtranjero(idPais) {
  const url = `${basePath}/registroJuntas/sedesVotoExtranjero`;
  const jwt = getAccessTokenApi();
  return axios.post( url, {idPais: idPais}, { headers: { Authorization: jwt }});
}

export function obtenerURLImagen() {
  const url = `${basePath}/solicitud/imagen`;
  const jwt = getAccessTokenApi();
  return axios.post(
    url,
    { headers: { Authorization: jwt } }
  );
}
